var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nut-infiniteloading',{attrs:{"is-show-mod":_vm.isShowMod,"has-more":!_vm.isNoMore,"is-loading":_vm.isLoading,"unload-more-txt":_vm.noMoreText,"threshold":_vm.threshold},on:{"loadmore":_vm.loadMoreClick}},[_vm._t("list"),_vm._v(" "),_c('no-data',{attrs:{"data":_vm.data}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f15f3f22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/comp/ListLoading/ListLoading.vue
// module id = null
// module chunks = 